import request from '@/middleware/request'

const getCampaignList = () => {
  return request({
    url: '/campaigns',
    method: 'get'
  })
}
const getCampaignIndex = id => {
  return request({
    url: `/campaigns/${id}`,
    method: 'get'
  })
}

const getCampaign = data => {
  return request({
    url: '/campaigns/search',
    method: 'post',
    data
  })
}
const createCampaign = data => {
  return request({
    url: '/campaigns',
    method: 'post',
    data
  })
}
const createCampaignWithFile = formData => {
  return request({
    url: '/campaigns/file',
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
const updateCampaign = (id, data) => {
  return request({
    url: `/campaigns/${id}`,
    method: 'patch',
    data
  })
}
const updateCampaignWithFile = (id, formData) => {
  return request({
    url: `/campaigns/file/${id}`,
    method: 'patch',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
const updateCampaignEnable = (id, data) => {
  return request({
    url: `/campaigns/enable/${id}`,
    method: 'patch',
    data
  })
}
const deleteCampaign = id => {
  return request({
    url: `/campaigns/${id}`,
    method: 'delete'
  })
}

const getCampaignLog = data => {
  return request({
    url: '/campaigns/log/search',
    method: 'post',
    data
  })
}
const createCampaignLog = data => {
  return request({
    url: '/campaigns/log',
    method: 'post',
    data
  })
}
const updateCampaignLog = (id, data) => {
  return request({
    url: `/campaigns/log/${id}`,
    method: 'patch',
    data
  })
}
const deleteCampaignLog = id => {
  return request({
    url: `/campaigns/log/${id}`,
    method: 'delete'
  })
}
const cloneCampaign = data => {
  return request({
    url: '/campaigns/clone',
    method: 'post',
    data
  })
}

const writeCSV = data => {
  return request({
    url: '/campaigns/writeCSV',
    method: 'post',
    data
  })
}

const writeCommonCSV = data => {
  return request({
    url: '/campaigns/writeCommonCSV',
    method: 'post',
    data
  })
}

const readJson = formData => {
  return request({
    url: '/campaigns/readJson',
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export default {
  getCampaignList,
  getCampaignIndex,
  getCampaign,
  createCampaign,
  createCampaignWithFile,
  updateCampaign,
  updateCampaignWithFile,
  updateCampaignEnable,
  deleteCampaign,

  getCampaignLog,
  createCampaignLog,
  updateCampaignLog,
  deleteCampaignLog,
  cloneCampaign,

  writeCSV,
  writeCommonCSV,
  readJson
}
